export enum PreparationOrderStatus {
    TO_PREPARE = "TO_PREPARE",
    PREPARING = "PREPARING",
    PREPARED = "PREPARED",
    DELIVERED = "DELIVERED",
    CANCELED = "CANCELED",
    FAILED = "FAILED"
}
